module.exports = __webpack_public_path__ + "assets/img/1_626.16441cf5.jpg";